export { WordCloud, IWordCloudSettings, IWordCloudDataItem, IWordCloudPrivate } from "./.internal/charts/wordcloud/WordCloud";
import { WordCloudDefaultTheme } from "./.internal/charts/wordcloud/WordCloudDefaultTheme";
export { WordCloudDefaultTheme as DefaultTheme };